import { render, staticRenderFns } from "./Creatives.vue?vue&type=template&id=61b605f1&"
import script from "./Creatives.vue?vue&type=script&lang=js&"
export * from "./Creatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports